import React from "react";
import { NumberInput } from "react-admin";
import Button from "@material-ui/core/Button";

const PremiumWithLogsButton = ({ onLogsClick }) => {
    return (
        <div
            style={{
                display: "flex",
                alignItems: "flex-end",
                width: "100%",
            }}
        >
            <div style={{ flex: 1 }}>
                <NumberInput
                    source="netPremium"
                    label="Expiring Premium"
                    fullWidth
                />
            </div>

            <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={onLogsClick}
                style={{
                    marginLeft: "10px",
                    marginBottom: "8px",
                    height: "25px",
                    whiteSpace: "nowrap",
                }}
            >
                Prem. Logs
            </Button>
        </div>
    );
};

export default PremiumWithLogsButton;
